import { TWhiteLabelStore } from '../white-label.model';

export function setPanelBg(themeWrapper: HTMLBodyElement, whiteLabel: TWhiteLabelStore): void {
  themeWrapper.style.setProperty('--panelBg', whiteLabel.data.panelBg);
}
